import LocationAdapter from '@javascripts/adapters/location_adapter';

export default class OverrideVideoPoster {
  constructor(tech) {
    this._tech = tech;
  }

  init() {
    if (LocationAdapter.href().indexOf('utm_campaign=instagram') != -1) {
      this.setVideoPoster();
    }
  }

  setVideoPoster() {
    const video = document.querySelector('.video-js video');
    video.setAttribute('poster', this.posterBase64());
  }

  tech() {
    return this._tech;
  }

  posterBase64() {
    return 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABAQMAAAAl21bKAAAABlBMVEUzMzOWlpbkf4Z6AAAACXBIWXMAAA7EAAAOxAGVKw4bAAAACklEQVQImWNgAAAAAgAB9HFkpgAAAABJRU5ErkJggg==';
  }
}
